import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Bookmark } from '../../models/bookmark';
import { withBookmarkSelectors } from './bookmark.selectors';
import { BookmarkService } from '../../services/bookmark/bookmark.service';
import { inject } from '@angular/core';
import { ActiveUserStore } from '../user/active-user.state';
import { withLogging } from '../features/logger.feature';

export type BookmarkState = BaseState<Bookmark>;

export const initialState: BookmarkState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Bookmark',
  entityLabel: 'Ansichten',
  filter: {
    query: '',
    category: [],
    tags: [],
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
  events: {
    add: ['bookmarkAdded'],
    update: ['bookmarkUpdated'],
  },
};

export const BookmarkStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Bookmark>(BookmarkService),
  withLogging(initialState.entityType),
  withBookmarkSelectors(),
  withMethods((store, bookmarkService = inject(BookmarkService)) => ({
    /**
     * fill pool state with pool-indicators
     */
    async findByCategoryIds(categoryIds: string[]) {
      patchState(store, { loading: true });

      const items = await bookmarkService.getByCategoryIds(categoryIds);
      patchState(store, {
        items: items,
        loading: false,
        initialized: true,
        itemsLoaded: true,
      });
    },
    async fetchByToken(categoryIds: string[]) {
      patchState(store, { loading: true });

      const items = await bookmarkService.getByCategoryIds(categoryIds);
      patchState(store, {
        items: items,
        loading: false,
        initialized: true,
        itemsLoaded: true,
      });
    },
  })),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      if (
        activeUserStore.canSeeAllInWorkspaceType('bookmarkCategory') &&
        activeUserStore.context() === 'dataBackend'
      ) {
        store.loadAllItemsByPromise();
      }
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
